import config from "../config";

export async function fetchFinancialBeforeAfter(backendFetch, siteId, fromts, tots) {
  const url = `${config.REACT_APP_HOST}/api/v2/metering/financial/before-after/${siteId}?fromts=${fromts}&tots=${tots}`;
  const f = await backendFetch(url);
  return await f.json();
}

export async function fetchFinancialCreditLine(backendFetch, siteId, fromts, tots) {
  const url = `${config.REACT_APP_HOST}/api/v2/metering/creditline/${siteId}?fromts=${fromts}&tots=${tots}`;
  const f = await backendFetch(url);
  return await f.json();
}

export async function downloadBeforeAfterDocument(backendFetch) {
  const url = `${config.REACT_APP_HOST}/api/v2/financial/before-after/download`;
  const response = await backendFetch(url);
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", "voor-vs-na.pdf");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}
